import React from 'react';
import '../components/css/popupstyle.css';
import $ from 'jquery';
import loader from '../../src/components/css/dark/img/loader.gif';

class ConfirmDeletePopup extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            password: '',
            cpassword: '',
            btnClick: false
        };
    }
    componentDidMount() {

    }
    componentDidUpdate() {

    }

    handleTextChange1 = e => {
        $('#passwordField').addClass('errorIcon');
        $('.password').hide();
    }
    handleTextChange2 = e => {
        $('.re-password').hide();
        $('#confirmPasswordField').addClass('errorIcon');
    }

    HandleResetPWD = e => {
        let fieldValue = [];
        let field1 = $('input[name=password]').val();
        let field2 = $('input[name=confirmPassword]').val();

        $('#passwordField').removeClass('errorIcon');
        $('#confirmPasswordField').removeClass('errorIcon');

        if (field1 == '' || field1 == null || field1 == undefined) {
            $('#passwordField').addClass('errorIcon');
            $('.password').show();
            $('.password').text('New password is required');
        }
        if (field2 == '' || field2 == null || field2 == undefined) {
            $('#confirmPasswordField').addClass('errorIcon');
            $('.re-password').show();
            $('.re-password').text('Confirm new password is required');
        }

        if ($('input[name=password]').val().length > 0 && $('input[name=password]').val().length < 8) {
            $('#passwordField').addClass('errorIcon');
            $('.password').show();
            $('.password').text('Password must be at least 8 characters');
        }
        if ($('input[name=confirmPassword]').val().length > 0 && $('input[name=confirmPassword]').val().length < 8) {
            $('#confirmPasswordField').addClass('errorIcon');
            $('.re-password').show();
            $('.re-password').text('New Password and Confirm Password must match');
        }
        if ($('input[name=password]').val().length >= 8 && $('input[name=confirmPassword]').val().length >= 8) {
            if ($('input[name=password]').val() != $('input[name=confirmPassword]').val()) {
                $('#passwordField').addClass('errorIcon');
                $('#confirmPasswordField').addClass('errorIcon');
                $('.re-password').show();
                $('.re-password').text('New Password and Confirm Password must match');
            }
            else {
                this.setState({ btnClick: true });
                fieldValue.push(field1);
                fieldValue.push(field2);
                this.props.handleSubmit(fieldValue);
            }
        }
    }
    render() {
        return (

            <div className='tool-section report confirmClose adminConfirmPassword'>
                <div className='popup report-section'>
                    <div className='popup_inner'>

                        <h1>{this.props.titleText}</h1>
                        {
                            this.props.titleText == "Click on confirm to add a dashboard" ?
                                <div className="pop-btn">
                                    <button className="btn" onClick={this.props.handleConfirmCreate}>Confirm</button>
                                    <button className="btn cancel" onClick={this.props.CloseCreatPopup}>No</button>
                                    <img id="DeletePopupLoader" className="loader confirmClick" src={loader} alt="loader" />
                                </div> : null
                        }
                        {
                            this.props.titleText == "Are you sure want to delete this dashboard?" ?
                                <div className="pop-btn">
                                    <button className="btn" onClick={this.props.handleCondition}>Yes</button>
                                    <button className="btn cancel" onClick={this.props.closePopup}>No</button>
                                    <img id="DeletePopupLoader" className="loader confirmClick" src={loader} alt="loader" />
                                </div> : null
                        }    {
                            this.props.titleText == "Change Password" ?
                                <div className="pop-btn resendPassword">
                                    <input type="password" className="form-control" id="passwordField" name="password" placeholder="New Password" autocomplete="new-password" onKeyUp={this.handleTextChange1} />
                                    <div className="error-message password"></div>
                                    <input type="password" className="form-control" id="confirmPasswordField" name="confirmPassword" placeholder="Confirm New Password" autocomplete="new-password" onKeyUp={this.handleTextChange2} />
                                    <div className="error-message re-password"></div>
                                    <div className="clear"></div>
                                    <button className="btn" onClick={this.HandleResetPWD}>Submit</button>
                                    <button className="btn cancel" onClick={this.props.closeResendPopup}>Cancel</button>
                                    {
                                        this.state.btnClick == true ?
                                            <img className="loader confirmClick" src={loader} alt="loader" /> : null
                                    }
                                </div> : null
                        }
                    </div>
                </div>
            </div>

        )
    }
}

export default ConfirmDeletePopup;